/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductConversionFieldDto } from '../../models/backend-advanced-product-conversion-field-dto';
import { BackendAdvancedProductConversionFieldRequestDto } from '../../models/backend-advanced-product-conversion-field-request-dto';

export interface SalesAdvancedProductConversionFieldsUpdate$Params {
  id: number;
  body: BackendAdvancedProductConversionFieldRequestDto;
}

export function salesAdvancedProductConversionFieldsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductConversionFieldsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductConversionFieldsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductConversionFieldDto>;
    }),
  );
}

salesAdvancedProductConversionFieldsUpdate.PATH = '/api/sales/advanced-product-conversion-fields/{id}/';
